import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import { useQuery } from '@tanstack/react-query'
import { IItem } from '../../../../api/types/item'
import { itemsQueryKey } from '../../../../api/queries'
import { queryItems } from '../../../../api/queries'
import { Box, Button, ImageList, TextField, Theme } from '@mui/material'
import { fromAxiosError } from '../../../../context/GlobalError'
import { ErrorHandler } from '../../../../components/ErrorHandler/ErrorHandler'
import { ItemFormModal } from '../ItemFormModal/ItemFormModal'
import { createStyles, makeStyles } from '@mui/styles'
import { Item } from '../Item/Item'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    table: {
      minWidth: 650,
      border: 'none',
    },

    button: {
      margin: theme.spacing(0.5),
    },
  })
)

export const ItemsList: React.FC<{
  columns?: number
  reverseBackground?: boolean
  displayFilteredOnly?: boolean
  additionalItemActions?: any
}> = ({
  columns = 2,
  reverseBackground = false,
  displayFilteredOnly = false,
  additionalItemActions,
}) => {
  const { isLoading, error, data: items } = useQuery<IItem[]>(itemsQueryKey(), queryItems)
  const classes = useStyles()
  const [nameFilter, setNameFilter] = useState('')

  return (
    <>
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ display: 'flex', width: '100%' }}>
            <Box sx={{ width: '100%' }}>
              <TextField
                label="Szukaj..."
                onChange={e => setNameFilter(e.target.value)}
                sx={{ marginTop: '4px', marginRight: '4px', width: '100%' }}
                size={'small'}
                value={nameFilter}
              />
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <ItemFormModal title={'Stwórz nowy przedmiot'}>
                {showModal => (
                  <Button
                    variant="outlined"
                    className={classes.button}
                    color="primary"
                    sx={{ height: '40px' }}
                    startIcon={<AddIcon />}
                    onClick={showModal}
                  >
                    Stwórz
                  </Button>
                )}
              </ItemFormModal>
            </Box>
          </Box>
        </Box>
        <Box className={classes.itemsContainer}>
          <ImageList variant="masonry" cols={columns} gap={8}>
            {items &&
              ((displayFilteredOnly && nameFilter.length > 0) || !displayFilteredOnly) &&
              items
                .filter(i => i.name.toLowerCase().includes(nameFilter.toLowerCase()))
                .map(i => (
                  <Box sx={{ marginBottom: '8px' }} key={i.id}>
                    <Item
                      additionalActions={additionalItemActions}
                      reverseBackground={reverseBackground}
                      item={i}
                    />
                  </Box>
                ))}
            {!items && <></>}
          </ImageList>
        </Box>
      </ErrorHandler>
    </>
  )
}
